import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=e3ba8b96&lang=pug&"
import script from "./Location.vue?vue&type=script&lang=ts&"
export * from "./Location.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports